const isSnackbarShowReducer = (state, action) => {
  switch (action.type) {
    case 'SET_IS_SNACKBAR_SHOW': {
      return action.payload;
    }
    default:
      return state;
  }
};

export default function moreReducer(state, action) {
  const {
    isEdge, isTWA, twaVersion, isSnackbarShow,
  } = state;

  return {
    isEdge,
    isTWA,
    twaVersion,
    isSnackbarShow: isSnackbarShowReducer(isSnackbarShow, action),
  };
}
